<template>
  <div id="reset-password" class="d-flex justify-content-center">
    <b-overlay :show="loading" rounded="sm" no-wrap fixed>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="stopwatch" font-scale="2" animation="cylon"></b-icon>
        </div>
      </template>
    </b-overlay>

    <div style="width: 320px">
      <p class="text-center">
        <img
          alt="ТЭК-Торг Электронный документооборот"
          src="@/assets/logo.png"
        />
      </p>

      <Error
        v-if="errorText"
        :error-details="moreErrorInfo"
        :error-text="errorText"
        :large-text="false"
      />

      <section v-if="isPasswordReset">
        <h4 class="pt-2 pb-2 highlighting">
          Пароль успешно изменен
        </h4>

        <b-button-group class="d-flex mt-2">
          <b-button variant="edo" size="sm" @click="$router.push('/')"
            >Войти</b-button
          >
        </b-button-group>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Error from '@/components/error'
import { securityActor } from '@/urls'

export default {
  name: 'ResetPassword',
  components: {
    Error
  },
  data: () => ({
    errorText: '',
    moreErrorInfo: '',
    loading: false,
    isPasswordReset: false
  }),
  mounted() {
    this.resetPassword()
  },
  methods: {
    async resetPassword() {
      this.loading = true
      try {
        const url = `${securityActor}/password-reset/${this.$route.params.jwt}`
        await axios.put(url, null)
        this.isPasswordReset = true
      } catch (error) {
        this.moreErrorInfo = error.response
        this.errorText = 'Ошибка изменения пароля'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
